import React from "react";
import { useNavigate } from "react-router-dom";
import { homePageImages } from "../../utils/constants"

const SpreadingLoveBoxes = () => {
  const navigate = useNavigate();
  return (
    <div className="flex mt-3 flex-wrap justify-around gap-5 sm:gap-0 lg:justify-between mx-[3%] md:gap-[1.5rem] mb-[50px]">
        {/* 1st box */}
      <div
        className="w-[90%] border-[1px] lg:w-[30%] lg:h-[9.625rem] bg-[#F8F8F8] rounded-[2rem] lg:rounded-[3rem] flex p-[10px] lg:p-[1rem] gap-[1rem] relative"
        onClick={() => navigate("/about#who")}
      >
        <div className="">
          <img
            src={homePageImages?.boyChildImg}
            className=" h-[80px] sm:h-[100px] sm:w-[130px] w-[100px] object-cover"
            alt="childavatar1"
            loading="eager"
          />
        </div>
        <div className="h-full cursor-pointer">
          <p
            className={
              "text-[#D31C4F] lg:mt-[8px] text-2xl lg:text-[1.88rem] !font-medium "
            }
          >
            Who We are?
          </p>
          <p className="lg:text-[1.125rem] mt-[6px]">Most Loved Preschool</p>
          <button
            className={
              "mt-[1rem] text-base cursor-pointer sm:text-[1.5rem] !font-semibold "
            }
          >
            Know More
          </button>
        </div>
        <div className="absolute right-[5%] bottom-[5%]">
          <img
            src={homePageImages?.playImg}
            className="size-[40px] sm:size-[4rem]"
            alt="play"
            loading="eager"
          />
        </div>
      </div>
      {/* 2nd box */}
      <div
        className="w-[90%] border-[1px] lg:w-[30%] lg:h-[9.625rem] bg-[#F8F8F8] rounded-[2rem] lg:rounded-[3rem] flex p-[10px] lg:p-[1rem] gap-[1rem] relative cursor-pointer"
        onClick={() => navigate("/about#vision")}
      >
        <div className="size-[5rem] p-2">
          <img
            src={homePageImages?.markerImg}
            className=" object-cover h-[120px] sm:h-[130px] sm:pb-3 pb-2 sm:w-[150px] w-[100px]"
            alt="childavatar1"
           
            loading="eager"
          />
        </div>
        <div className="h-full">
          <p className={"text-[#D31C4F] text-[1.88rem] !font-medium "}>
            Our Vision
          </p>
          <p className="text-[1.125rem]">Sound Foundation for Life </p>
          <button
            className={
              "mt-[1rem] text-base cursor-pointer sm:text-[1.5rem] !font-semibold "
            }
          >
            Know More
          </button>
        </div>
        <div className="absolute right-[5%] bottom-[5%]">
          <img
            src={homePageImages?.playImg}
            className="size-[40px] sm:size-[4rem]"
            alt="play"
            loading="eager"
          />
        </div>
      </div>
      {/* 3rd box */}
      <div className="w-[90%] border-[1px] lg:w-[30%] cursor-pointer lg:h-[9.625rem] bg-[#F8F8F8] rounded-[2rem] lg:rounded-[3rem] flex p-[10px] lg:p-[1rem] gap-[1rem] relative"
      onClick={() => navigate("/about#mission")}
      >
        <div className="size-[4.8rem] p-1">
          <img
            src={homePageImages?.boyBoardImg}
            className=" object-cover"
            alt="childavatar1"
            width={150}
            height={150}
            loading="eager"
          />
        </div>
        <div
          className="h-full cursor-pointer"
        >
          <p className={"text-[#D31C4F] text-[1.88rem] !font-medium "}>
            Our Mission
          </p>
          <p className="text-[1.125rem]">Transformation of Education</p>
          <button
            className={
              "mt-[1rem] text-base cursor-pointer sm:text-[1.5rem] !font-semibold "
            }
          >
            Know More
          </button>
        </div>
        <div className="absolute right-[5%] bottom-[5%]">
          <img
            src={homePageImages?.playImg}
            className="size-[40px] sm:size-[4rem]"
            alt="play"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default SpreadingLoveBoxes;
